import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 3.12602V2H11V3.12602C9.27477 3.57006 8 5.13616 8 7H5V9H6V10H18V9H19V7H16C16 5.13616 14.7252 3.57006 13 3.12602Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 12H22V14H21V20H22V22H16V20C16 17.7909 14.2091 16 12 16C9.79086 16 8 17.7909 8 20V22H2V20H3V14H2V12Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 20C10 18.8954 10.8954 18 12 18C13.1046 18 14 18.8954 14 20V22H10V20Z"}}]};

const PalaceFilled = Vue.extend<IconProps>({
  name: 'PalaceFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'palace-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PalaceFilled;
